import {
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
  Switch,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface Props extends Omit<FormControlLabelProps, 'control' | 'label'> {
  name: string;
  title: string;
  subtitle?: string;
  helperText?: React.ReactNode;
  handleChange?: () => void;
  column?: boolean;
  label?: any;
  positionLabel?:FormControlLabelProps['labelPlacement']
}

const RHFSwitchV2 = ({
  name,
  helperText,
  column,
  title,
  subtitle,
  positionLabel = 'start',
  ...other
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            labelPlacement={positionLabel}
            control={<Switch {...field} checked={field.value} />}
            {...other}
            label={
              <>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  {title}
                </Typography>
                {subtitle ? (
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {subtitle}
                  </Typography>
                ) : null}
              </>
            }
            sx={{ mx: 0, mb: 1, width: 1, justifyContent: 'space-between' }}
          />

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </>
      )}
    />
  );
};

export default RHFSwitchV2;
